import gif from './loading-30.gif'

export default function loadingGif({width = 48}:{width?:number}){
  return (
    <div className="has-text-centered" style={{"padding":"50px","height":"50vh"}}>
      <img src={gif} width={`${width}`} alt="Loading" />
    </div>
  );
}
